import React, { Component } from 'react';
import Loader from '../../../components/Loader';
import ArticleForm from '../../../components/ArticleForm';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';
import { statuses, types } from '../../../constants/document';

class ArticleItemPage extends Component {
  constructor(props) {
    super(props);

    this.state = { fromProps: {} };

    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  static getDerivedStateFromProps(nextProps, state) {
    const {
      match: {
        params: { id },
      },
    } = nextProps;
    const newState = { fromProps: state.fromProps };

    if (id !== state.fromProps.id) {
      newState.fromProps.id = id;
    }

    return newState;
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      fromProps: { id },
    } = this.state;
    if (prevState.fromProps.id !== id) {
      if (id && id !== 'new') {
        this.props.fetch(id);
      }
    }
  }

  componentDidMount() {
    const {
      fetch,
      getTypes,
      match: {
        params: { id },
      },
    } = this.props;
    getTypes();
    if (id && id !== 'new') {
      fetch(id);
    }
  }

  save({ id, status, subType, lang, file, pdf, related, categories }) {
    const { add, update, setFile } = this.props;
    const files = [];
    const data = {
      id,
      status,
      subType,
      lang,
      related,
    };
    if (file && typeof file.url === 'object') {
      if (file.url === null) {
        data.removeFile = true;
      } else {
        file.url.fileKey = 'file';
        files.push(file.url);
      }
    }
    if (pdf && typeof pdf.url === 'object') {
      if (pdf.url === null) {
        data.removePdf = true;
      } else {
        pdf.url.fileKey = 'pdf';
        files.push(pdf.url);
      }
    }
    setFile(files);
    if (id) {
      update({ id, ...data });
    } else {
      add({ ...data });
    }
  }

  remove() {
    const yes = window.confirm('Are you sure you want delete this item?');
    if (!yes) return;
    const { articleItem, remove } = this.props;
    if (articleItem.id) {
      remove(articleItem.id);
    }
  }

  cancel() {
    const yes = window.confirm('Are you sure?');
    if (!yes) return;
    this.props.history.push(ROUTES.ADMIN_ARTICLES);
  }

  getDefaultValues() {
    const { types } = this.props;
    if (types.length) {
      return {
        status: statuses.DRAFT,
        subType: types[0],
        categories: [],
      };
    }
    return null;
  }

  getItemForForm() {
    const { articleItem } = this.props;

    if (articleItem.id) return articleItem;
    return {};
  }

  render() {
    const {
      loading,
      saving,
      articleItem,
      match: {
        params: { id },
      },
    } = this.props;
    const isNew = id === 'new';

    return (
      <>
        {(loading || saving) && <Loader type="fixed" />}
        <Container fluid className="py-2 border-bottom">
          <Row className="justify-content-between align-items-center">
            <Col>
              <h2 className="display-2 mb-0">
                {isNew ? 'New' : 'Edit'} article
              </h2>
            </Col>
            <Col className="text-right">
              <Link
                to={`${ROUTES.ADMIN_ARTICLE_ITEM_PARAM}new`}
                className="btn btn-primary btn-icon"
              >
                <span className="btn-inner--icon">
                  <i className="ni ni-fat-add" />
                </span>
                <span className="btn-inner--text">New</span>
              </Link>
              <Button
                onClick={this.cancel}
                className="btn btn-warning btn-icon"
              >
                <span className="btn-inner--icon">
                  <i className="ni ni-fat-remove" />
                </span>
                <span className="btn-inner--text">Cancel</span>
              </Button>
            </Col>
          </Row>
        </Container>
        <Container className="pb-5">
          <Row>
            <Col>
              {isNew || !articleItem || !articleItem.id ? (
                <ArticleForm
                  isNew={isNew}
                  onSubmit={this.save}
                  onDelete={this.remove}
                  file={null}
                  pdf={null}
                  initialValues={this.getDefaultValues()}
                />
              ) : (
                <ArticleForm
                  isNew={false}
                  onSubmit={this.save}
                  onDelete={this.remove}
                  file={articleItem.file}
                  pdf={articleItem.pdf}
                  initialValues={this.getItemForForm()}
                  relatedDocument={articleItem.related.find(
                    rItem => rItem.type === types.DOCUMENT,
                  )}
                  relatedAudio={articleItem.related.find(
                    rItem => rItem.type === types.AUDIO,
                  )}
                />
              )}
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default ArticleItemPage;
